import { Button } from '@1trading/react/components/ui/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@1trading/react/components/ui/dropdown-menu';
import { useTranslation } from 'react-i18next';

import Flag, { type CountryCode } from '@/components/ui/flag';
import { persistLanguage } from '@/lib/firebase/persist-language';
import { LOCALES, type Locale } from '@/lib/i18n';

const LOCALE_COUNTRY_CODE_MAP = {
  de: 'de',
  en: 'gb',
  nl: 'nl',
} as const satisfies Record<Locale, CountryCode>;

const LanguageMenu = () => {
  const { i18n } = useTranslation();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" className="uppercase">
          {i18n.language}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {LOCALES.map((locale) => (
          <DropdownMenuItem
            key={locale}
            className="gap-2 uppercase"
            isActive={i18n.language === locale}
            onClick={() => {
              void i18n.changeLanguage(locale);
              void persistLanguage(locale);
            }}
          >
            <Flag countryCode={LOCALE_COUNTRY_CODE_MAP[locale]} />
            {locale}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
LanguageMenu.displayName = 'LanguageMenu';

export default LanguageMenu;
